import http from '@/common/request/axios';

export const rubyService = {
    transaction: {
        list({ offset, limit, accountId }: any) {
            return http.doGet('admin/ruby/transaction/' + accountId, { offset, limit });
        }
    }
};
